/** The rate in force today for one role, and where it comes from. */
import type { CurrentRate } from '../../../api/staff-pay-rates';

import { describeDefaultKey, formatCalendarDate, formatRateCents } from './pay-rate-format';

export default function CurrentRateSummary({ current }: { current: CurrentRate }) {
  if (current.source === 'none' || current.amountCents === null) {
    return <span className="text-sm text-stone-400 italic">Not set</span>;
  }
  const since = current.effectiveFrom ? ` since ${formatCalendarDate(current.effectiveFrom)}` : '';
  const source =
    current.source === 'personal'
      ? `personal rate${since}`
      : `default, ${describeDefaultKey(current.defaultRateKey)}`;
  return (
    <span className="text-sm">
      <span className="font-semibold text-bark-900 dark:text-stone-100">
        {formatRateCents(current.amountCents)}
      </span>
      <span className="ml-2 text-xs text-stone-500 dark:text-stone-400">{source}</span>
    </span>
  );
}
